var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cases-con"},[_c('Banner'),_c('cases-ka'),_c('Cases-item',{attrs:{"showNumber":_vm.showNumber}}),_c('customer-recognition'),_c('digital-marketing'),_c('marketing-upgrade')],1)}
var staticRenderFns = []

export { render, staticRenderFns }